export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14920.ba3f1b8f.jpg";